const PERMISSIONS = {
  "org:manage": ["owner"],
  "members:manage": ["owner", "admin"],
  "billing:manage": ["owner", "admin"],
  "emailSettings:manage": ["owner", "admin"],
  "campaigns:write": ["owner", "admin", "editor"],
  "contacts:write": ["owner", "admin", "editor"],
  "forms:write": ["owner", "admin", "editor"],
  "templates:write": ["owner", "admin", "editor"],
  "*:read": ["owner", "admin", "editor", "viewer"],
};

export function getCurrentRole() {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};
  return user.role || "owner";
}

export function hasPermission(permission) {
  const role = getCurrentRole();
  const allowed = PERMISSIONS[permission];
  if (!allowed) return false;
  return allowed.includes(role);
}

export function canWriteResources() {
  return hasPermission("campaigns:write");
}

export function canManageBilling() {
  return hasPermission("billing:manage");
}

export function canManageMembers() {
  return hasPermission("members:manage");
}

export function canManageOrg() {
  return hasPermission("org:manage");
}

export function canManageEmailSettings() {
  return hasPermission("emailSettings:manage");
}
